<template>
    <div class="text-center row mt-5 justify-content-center">
        <h6>Iniciar Sesión</h6>
        <form 
        autocomplete="off" 
        class="mb-5 col-md-6 col-12" 
        v-on:submit.prevent="Login">
          <div class="mb-3">
            <input 
            :disabled="loading"
            v-model="email"
            type="email" 
            class="form-control text-center" 
            id="email" />
          </div>
          <div class="mb-3">
            <input 
            :disabled="loading"
            v-model="password"
            type="password" 
            class="form-control text-center" 
            id="password" />
          </div>
          <div class="m-3">
            <button
            :disabled="email.length==0 || password.length==0 || loading" 
            type="submit" 
            class="btn btn-primary">
              Comenzar
              <i 
              v-if="loading"
              class="ml-1 fas fa-spinner fa-spin"></i>
            </button>
          </div>
        </form>
    </div>
</template>

<script>
import {auth} from '@/firebase.js';
export default {
  data(){
    return {
      loading:false,
      email:'',
      password:''
    }
  },
  methods:{
    Login(){
      this.loading=true;
      auth.signInWithEmailAndPassword(this.email, this.password)
      .catch((error) => {
        this.loading=false;
        if (error.code=='auth/user-not-found') {
            swal('Error','Usuario no encontrado','error');
        }else if (error.code=='auth/wrong-password') {
            swal('Error','Contraseña Incorrecta','error');
        }else{
            swal('Error',error.message,'error');    
        }
      });
    },
  },
  mounted(){
    
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue